import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js"
import PullablePart from "components/pulled/PullablePart.js";
import {PLANAR_SNAPSHOTS} from 'constants/pullable-types.js';
import {connect} from 'react-redux';

const PlaneSnapshots = ({isDraggable=true, effect, currentSnapshot, currentSnapshotIndex, _snapshots}) => { 
    let [snapshots, setSnapshots] = useState(effect.snapshots);
    let [selected, setSelected] = useState(effect.currentSnapshot);

    useEffect(() => {
        setSelected(snapshots[effect.currentSnapshotParameter.get()]);
    }, [currentSnapshotIndex, setSelected]);

    useEffect(() => {
        if (_snapshots) {
            setSnapshots([... _snapshots]);
        }
    }, [_snapshots]);

    const takeSnapshot = useCallback(() => {
        effect.takeSnapshot();
        setSnapshots([... effect.snapshots]);
        setSelected(effect.currentSnapshot);
    }, [setSnapshots, effect, setSelected]);

    const useSnapshot = useCallback((snap) => {
        let index = snapshots.indexOf(snap);
        if (effect.currentSnapshotParameter.get() === index) {
            effect.currentSnapshotParameter.set(-1);
        } else {
            effect.currentSnapshotParameter.set(
                snapshots.indexOf(snap), false);
        }
    }, [effect, setSelected, snapshots]);

    const deleteSnapshot = useCallback(() => {
        effect.deleteSnapshot(selected);
        setSnapshots([... effect.snapshots]);
        setSelected(undefined);
    }, [effect, selected, setSelected, setSnapshots]);
    
    return (
        <PullablePart
          isDraggable={isDraggable}
          effect={effect}
          instrument={effect.snapshotComponent}
          type={PLANAR_SNAPSHOTS}
          className="snapshots-container">
          <div className="snapshot-toolbar">
            <EffectParameterSlider
              parameter={effect.currentSnapshotParameter}
              hideSlider={true}
              name="Snapshots"/>
            <div onClick={takeSnapshot} className="plane-snapshot-btn">+</div>
            {selected ? <div onClick={deleteSnapshot} className="delete-snapshot plane-snapshot-btn">-</div> : ''}
          </div>
          <div className="snapshots-list">
            {snapshots.map(
                (snap, i) =>
                    <div
                      key={i}
                      onClick={() => useSnapshot(snap)}
                      className={snap === selected ? "snapshot current" : "snapshot"}>
                      {i+1}
                    </div>)}
          </div>
        </PullablePart>
    );
}

const mapStateToProps = (state, props) => {
  return {
      // currentSnapshot: props.effect.currentSnapshot,
      _snapshots: props.effect.snapshots,
      currentSnapshotIndex: props.effect.currentSnapshotParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneSnapshots);
